import { Lead } from '../types';
import { LeadFormMetadata, LeadRealSource, LeadSourceInfo } from '../types/leadFormData';

export function parseLeadFormData(lead: Lead): LeadFormMetadata {
  const formData = lead.formData || {};

  let realSource: LeadRealSource = null;
  let isQualified: boolean | null = null;
  let projectDescription: string | null = null;
  let budgetRange: string | null = null;
  let estimatedTimeframe: string | null = null;
  let projectType: string | null = null;

  if (formData.qualified !== undefined) {
    isQualified = formData.qualified === true || formData.qualified === 'true';
  }

  if (formData.contactData?.message) {
    const message = formData.contactData.message;

    if (message.includes('elevenlabs_web') || message.includes('ElevenLabs Web')) {
      realSource = 'elevenlabs_web';
    } else if (message.includes('elevenlabs_whatsapp') || message.includes('ElevenLabs WhatsApp')) {
      realSource = 'elevenlabs_whatsapp';
    } else if (message.includes('web_form') || message.includes('Formulario Web')) {
      realSource = 'web_form_contacto';
    }

    const qualifiedMatch = message.match(/es_qualified[:\s]+(\w+)/i);
    if (qualifiedMatch && isQualified === null) {
      isQualified = qualifiedMatch[1].toLowerCase() === 'true' || qualifiedMatch[1].toLowerCase() === 'sí';
    }

    const descriptionMatch = message.match(/descripcion[:\s]+(.+?)(?=\n\w+:|$)/is);
    if (descriptionMatch) {
      projectDescription = descriptionMatch[1].trim();
    }

    const budgetMatch = message.match(/presupuesto[_\s]?(?:rango)?[:\s]+(.+?)(?=\n\w+:|$)/i);
    if (budgetMatch) {
      budgetRange = budgetMatch[1].trim();
    }

    const timeframeMatch = message.match(/plazo[_\s]?(?:estimado)?[:\s]+(.+?)(?=\n\w+:|$)/i);
    if (timeframeMatch) {
      estimatedTimeframe = timeframeMatch[1].trim();
    }

    const projectTypeMatch = message.match(/tipo[_\s]?(?:proyecto)?[:\s]+(.+?)(?=\n\w+:|$)/i);
    if (projectTypeMatch) {
      projectType = projectTypeMatch[1].trim();
    }
  }

  if (realSource === null) {
    if (lead.source === 'web_form_contacto') {
      realSource = 'web_form_contacto';
    } else if (lead.source === 'web_form_presupuesto') {
      realSource = 'web_form_presupuesto';
    } else if (lead.source === 'public_agenda') {
      realSource = 'public_agenda';
    }
  }

  return {
    realSource,
    isQualified,
    projectDescription,
    budgetRange,
    estimatedTimeframe,
    projectType
  };
}

export function getLeadRealSource(lead: Lead): LeadRealSource {
  const metadata = parseLeadFormData(lead);
  return metadata.realSource;
}

export function isLeadQualified(lead: Lead): boolean | null {
  const metadata = parseLeadFormData(lead);
  return metadata.isQualified;
}

export function getLeadSourceInfo(source: LeadRealSource): LeadSourceInfo {
  switch (source) {
    case 'elevenlabs_web':
      return {
        source: 'elevenlabs_web',
        label: 'ElevenLabs Web',
        icon: 'Bot',
        colorClass: 'text-teal-700',
        bgClass: 'bg-teal-50',
        borderClass: 'border-teal-200'
      };
    case 'elevenlabs_whatsapp':
      return {
        source: 'elevenlabs_whatsapp',
        label: 'ElevenLabs WhatsApp',
        icon: 'MessageCircle',
        colorClass: 'text-green-700',
        bgClass: 'bg-green-50',
        borderClass: 'border-green-200'
      };
    case 'web_form_contacto':
      return {
        source: 'web_form_contacto',
        label: 'Formulario Web',
        icon: 'Globe',
        colorClass: 'text-cyan-700',
        bgClass: 'bg-cyan-50',
        borderClass: 'border-cyan-200'
      };
    case 'web_form_presupuesto':
      return {
        source: 'web_form_presupuesto',
        label: 'Formulario Presupuesto',
        icon: 'FileText',
        colorClass: 'text-blue-700',
        bgClass: 'bg-blue-50',
        borderClass: 'border-blue-200'
      };
    case 'public_agenda':
      return {
        source: 'public_agenda',
        label: 'Agenda Pública',
        icon: 'Calendar',
        colorClass: 'text-purple-700',
        bgClass: 'bg-purple-50',
        borderClass: 'border-purple-200'
      };
    default:
      return {
        source: null,
        label: 'Desconocido',
        icon: 'FileText',
        colorClass: 'text-gray-700',
        bgClass: 'bg-gray-50',
        borderClass: 'border-gray-200'
      };
  }
}
